import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import FloatingSaveButton from './components/floating-save-button';
import { useHoverPreview } from './components/hover-preview';

interface SlotData {
  id: number;
  name: string;
  demoLink: string;
  bannerLink: string;
}

const SlotDemo = () => {
  const [id, setId] = useState('');
  const { handleMouseMove, handleMouseLeave, HoverPreviewComponent } = useHoverPreview();

  // Define state for each slot's demo link and banner
  const [slots, setSlots] = useState<SlotData[]>([
    { id: 1, name: 'Gates of Olympus', demoLink: '', bannerLink: '' },
    { id: 2, name: 'Starlight Princess', demoLink: '', bannerLink: '' },
    { id: 3, name: 'Aztec Games', demoLink: '', bannerLink: '' },
    { id: 4, name: 'Sweet Bonanza', demoLink: '', bannerLink: '' },
    { id: 5, name: 'Wild West Gold', demoLink: '', bannerLink: '' },
    { id: 6, name: 'Bonanza Xmas', demoLink: '', bannerLink: '' },
    { id: 7, name: 'Gates of Gatot Kaca', demoLink: '', bannerLink: '' },
    { id: 8, name: 'Barn Festival', demoLink: '', bannerLink: '' },
    { id: 9, name: 'Spaceman', demoLink: '', bannerLink: '' },
    { id: 10, name: 'Lions Megaways', demoLink: '', bannerLink: '' },
    { id: 11, name: 'Bonanza Gold', demoLink: '', bannerLink: '' },
    { id: 12, name: 'Fruit Party', demoLink: '', bannerLink: '' },
    { id: 13, name: 'Pyramid Bonanza', demoLink: '', bannerLink: '' },
    { id: 14, name: 'The Hand of Midas', demoLink: '', bannerLink: '' },
    { id: 15, name: 'Joker Jewels', demoLink: '', bannerLink: '' },
    { id: 16, name: 'Power of Thor', demoLink: '', bannerLink: '' },
    { id: 17, name: 'Wild Beach Party', demoLink: '', bannerLink: '' },
    { id: 18, name: 'Fruit Party 2', demoLink: '', bannerLink: '' },
    { id: 19, name: 'Fire Strike', demoLink: '', bannerLink: '' },
    { id: 20, name: 'Super X', demoLink: '', bannerLink: '' },
    { id: 21, name: 'Zombie Carnival', demoLink: '', bannerLink: '' },
    { id: 22, name: '888 Gold', demoLink: '', bannerLink: '' },
  ]);

  // Handle demo link change
  const handleDemoLinkChange = (index: number, value: string): void => {
    const updatedSlots = [...slots];
    updatedSlots[index].demoLink = value;
    setSlots(updatedSlots);
  };

  // Handle banner link change
  const handleBannerLinkChange = (index: number, value: string): void => {
    const updatedSlots = [...slots];
    updatedSlots[index].bannerLink = value;
    setSlots(updatedSlots);
  };

  // Save all slot data
  const save = async (): Promise<void> => {
    try {
      // Create the payload
      const payload = {
        id,
        linkDemoOlympus: slots[0]?.demoLink || '',
        linkBannerDemoOlympus: slots[0]?.bannerLink || '',
        linkDemoStarlightPrincess: slots[1]?.demoLink || '',
        linkBannerDemoStarlightPrincess: slots[1]?.bannerLink || '',
        linkDemoAztecGames: slots[2]?.demoLink || '',
        linkBannerDemoAztecGames: slots[2]?.bannerLink || '',
        linkDemoSweetBonanza: slots[3]?.demoLink || '',
        linkBannerDemoSweetBonanza: slots[3]?.bannerLink || '',
        linkDemoWildWestGold: slots[4]?.demoLink || '',
        linkBannerDemoWildWestGold: slots[4]?.bannerLink || '',
        linkDemoBonanzaXmas: slots[5]?.demoLink || '',
        linkBannerDemoBonanzaXmas: slots[5]?.bannerLink || '',
        linkDemoGatotKaca: slots[6]?.demoLink || '',
        linkBannerDemoGatotKaca: slots[6]?.bannerLink || '',
        linkDemoBarnFestival: slots[7]?.demoLink || '',
        linkBannerDemoBarnFestival: slots[7]?.bannerLink || '',
        linkDemoSpaceman: slots[8]?.demoLink || '',
        linkBannerDemoSpaceman: slots[8]?.bannerLink || '',
        linkDemo5Lions: slots[9]?.demoLink || '',
        linkBannerDemo5Lions: slots[9]?.bannerLink || '',
        linkDemoBonanzaGold: slots[10]?.demoLink || '',
        linkBannerDemoBonanzaGold: slots[10]?.bannerLink || '',
        linkDemoFruitParty: slots[11]?.demoLink || '',
        linkBannerDemoFruitParty: slots[11]?.bannerLink || '',
        linkDemoPyramidBonanza: slots[12]?.demoLink || '',
        linkBannerDemoPyramidBonanza: slots[12]?.bannerLink || '',
        linkDemoMidas: slots[13]?.demoLink || '',
        linkBannerDemoMidas: slots[13]?.bannerLink || '',
        linkDemoJokerJewel: slots[14]?.demoLink || '',
        linkBannerDemoJokerJewel: slots[14]?.bannerLink || '',
        linkDemoThor: slots[15]?.demoLink || '',
        linkBannerDemoThor: slots[15]?.bannerLink || '',
        linkDemoWildBeachParty: slots[16]?.demoLink || '',
        linkBannerDemoWildBeachParty: slots[16]?.bannerLink || '',
        linkDemoFruitParty2: slots[17]?.demoLink || '',
        linkBannerDemoFruitParty2: slots[17]?.bannerLink || '',
        linkDemoFireStrike: slots[18]?.demoLink || '',
        linkBannerDemoFireStrike: slots[18]?.bannerLink || '',
        linkDemoSuperX: slots[19]?.demoLink || '',
        linkBannerDemoSuperX: slots[19]?.bannerLink || '',
        linkDemoZombieCarnival: slots[20]?.demoLink || '',
        linkBannerDemoZombieCarnival: slots[20]?.bannerLink || '',
        linkDemo888Gold: slots[21]?.demoLink || '',
        linkBannerDemo888Gold: slots[21]?.bannerLink || '',
      };

      const response = await fetch(`/api/cms/update-slot-demo`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const res = await response.json();

      if (!response.ok) {
        throw new Error(res.errors?.[0]?.message || res.message || 'Gagal menyimpan data');
      }

      toast.success('Berhasil mengupdate data SLOT DEMO');
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Terjadi kesalahan ketika menyimpan data slot demo';
      toast.error(errorMessage);
      console.error('Terjadi kesalahan ketika menyimpan data slot demo:', error);
    }
  };

  useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await fetch(`/api/cms/get-data-slot-demo`);
        const res = await response.json();
        setId(res.data.id);

        // Initialize with all the slot data from your initial array
        const initialSlotData = [
          { id: 1, name: 'Gates of Olympus', demoLink: '', bannerLink: '' },
          { id: 2, name: 'Starlight Princess', demoLink: '', bannerLink: '' },
          { id: 3, name: 'Aztec Games', demoLink: '', bannerLink: '' },
          { id: 4, name: 'Sweet Bonanza', demoLink: '', bannerLink: '' },
          { id: 5, name: 'Wild West Gold', demoLink: '', bannerLink: '' },
          { id: 6, name: 'Bonanza Xmas', demoLink: '', bannerLink: '' },
          { id: 7, name: 'Gates of Gatot Kaca', demoLink: '', bannerLink: '' },
          { id: 8, name: 'Barn Festival', demoLink: '', bannerLink: '' },
          { id: 9, name: 'Spaceman', demoLink: '', bannerLink: '' },
          { id: 10, name: 'Lions Megaways', demoLink: '', bannerLink: '' },
          { id: 11, name: 'Bonanza Gold', demoLink: '', bannerLink: '' },
          { id: 12, name: 'Fruit Party', demoLink: '', bannerLink: '' },
          { id: 13, name: 'Pyramid Bonanza', demoLink: '', bannerLink: '' },
          { id: 14, name: 'The Hand of Midas', demoLink: '', bannerLink: '' },
          { id: 15, name: 'Joker Jewels', demoLink: '', bannerLink: '' },
          { id: 16, name: 'Power of Thor', demoLink: '', bannerLink: '' },
          { id: 17, name: 'Wild Beach Party', demoLink: '', bannerLink: '' },
          { id: 18, name: 'Fruit Party 2', demoLink: '', bannerLink: '' },
          { id: 19, name: 'Fire Strike', demoLink: '', bannerLink: '' },
          { id: 20, name: 'Super X', demoLink: '', bannerLink: '' },
          { id: 21, name: 'Zombie Carnival', demoLink: '', bannerLink: '' },
          { id: 22, name: '888 Gold', demoLink: '', bannerLink: '' },
        ];

        // Create mapping for API response to slots
        const fieldMapping = [
          { demoField: 'linkDemoOlympus', bannerField: 'linkBannerDemoOlympus', index: 0 },
          { demoField: 'linkDemoStarlightPrincess', bannerField: 'linkBannerDemoStarlightPrincess', index: 1 },
          { demoField: 'linkDemoAztecGames', bannerField: 'linkBannerDemoAztecGames', index: 2 },
          { demoField: 'linkDemoSweetBonanza', bannerField: 'linkBannerDemoSweetBonanza', index: 3 },
          { demoField: 'linkDemoWildWestGold', bannerField: 'linkBannerDemoWildWestGold', index: 4 },
          { demoField: 'linkDemoBonanzaXmas', bannerField: 'linkBannerDemoBonanzaXmas', index: 5 },
          { demoField: 'linkDemoGatotKaca', bannerField: 'linkBannerDemoGatotKaca', index: 6 },
          { demoField: 'linkDemoBarnFestival', bannerField: 'linkBannerDemoBarnFestival', index: 7 },
          { demoField: 'linkDemoSpaceman', bannerField: 'linkBannerDemoSpaceman', index: 8 },
          { demoField: 'linkDemo5Lions', bannerField: 'linkBannerDemo5Lions', index: 9 },
          { demoField: 'linkDemoBonanzaGold', bannerField: 'linkBannerDemoBonanzaGold', index: 10 },
          { demoField: 'linkDemoFruitParty', bannerField: 'linkBannerDemoFruitParty', index: 11 },
          { demoField: 'linkDemoPyramidBonanza', bannerField: 'linkBannerDemoPyramidBonanza', index: 12 },
          { demoField: 'linkDemoMidas', bannerField: 'linkBannerDemoMidas', index: 13 },
          { demoField: 'linkDemoJokerJewel', bannerField: 'linkBannerDemoJokerJewel', index: 14 },
          { demoField: 'linkDemoThor', bannerField: 'linkBannerDemoThor', index: 15 },
          { demoField: 'linkDemoWildBeachParty', bannerField: 'linkBannerDemoWildBeachParty', index: 16 },
          { demoField: 'linkDemoFruitParty2', bannerField: 'linkBannerDemoFruitParty2', index: 17 },
          { demoField: 'linkDemoFireStrike', bannerField: 'linkBannerDemoFireStrike', index: 18 },
          { demoField: 'linkDemoSuperX', bannerField: 'linkBannerDemoSuperX', index: 19 },
          { demoField: 'linkDemoZombieCarnival', bannerField: 'linkBannerDemoZombieCarnival', index: 20 },
          { demoField: 'linkDemo888Gold', bannerField: 'linkBannerDemo888Gold', index: 21 },
        ];

        // Populate data from API
        fieldMapping.forEach(mapping => {
          if (res.data[mapping.demoField] !== undefined) {
            initialSlotData[mapping.index].demoLink = res.data[mapping.demoField];
          }
          if (res.data[mapping.bannerField] !== undefined) {
            initialSlotData[mapping.index].bannerLink = res.data[mapping.bannerField];
          }
        });

        // Set state once with all data
        setSlots(initialSlotData);
      } catch (error) {
        console.error('Terjadi kesalahan ketika mengambil data slot demo:', error);
        toast.error('Gagal memuat data slot demo');
      }
    };

    fetchSlotData();
  }, []);

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
      {slots.map((slot, index) => (
        <div key={slot.id} className='bg-[#1c243b] rounded-lg shadow-lg p-6'>
          <h2 className='text-lg font-semibold mb-4 text-white'>{slot.name}</h2>

          {/* Demo Link Input */}
          <div className='mb-4'>
            <label className='block text-blue-400 text-sm font-medium mb-2'>Demo Link</label>
            <input
              type='text'
              value={slot.demoLink}
              onChange={e => handleDemoLinkChange(index, e.target.value)}
              placeholder='Enter demo link URL'
              className='w-full h-[45px] bg-[#212a40] text-white border border-gray-600 rounded-md px-4 focus:outline-none focus:border-blue-500'
            />
          </div>

          {/* Banner Link Input with validation styling */}
          <div className='mb-3'>
            <label className='block text-blue-400 text-sm font-medium mb-2'>Banner Image URL</label>
            <input
              type='text'
              value={slot.bannerLink}
              onChange={e => handleBannerLinkChange(index, e.target.value)}
              placeholder='Enter banner image URL'
              className='w-full h-[45px] bg-[#212a40] text-white border border-gray-600 rounded-md px-4 focus:outline-none focus:border-blue-500'
              onMouseMove={e => handleMouseMove(e, slot.bannerLink)}
              onMouseLeave={handleMouseLeave}
            />
          </div>
        </div>
      ))}

      {HoverPreviewComponent}

      <FloatingSaveButton onClick={save} />
    </div>
  );
};

export default SlotDemo;
